function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import _extends from "@babel/runtime/helpers/esm/extends";
import { GRID_DEFAULT_STRATEGY, useGridRegisterStrategyProcessor } from "../../core/strategyProcessing/index.js";
import { buildRootGroup, GRID_ROOT_GROUP_ID } from "./gridRowsUtils.js";
var createFlatRowTree = function(rows) {
    var tree = _define_property({}, GRID_ROOT_GROUP_ID, _extends({}, buildRootGroup(), {
        children: rows
    }));
    for(var i = 0; i < rows.length; i += 1){
        var rowId = rows[i];
        tree[rowId] = {
            id: rowId,
            depth: 0,
            parent: GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    return {
        groupingName: GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rows.length
        },
        dataRowIds: rows
    };
};
var updateFlatRowTree = function(param) {
    var previousTree = param.previousTree, actions = param.actions;
    var tree = _extends({}, previousTree);
    var idsToRemoveFromRootGroup = {};
    for(var i = 0; i < actions.remove.length; i += 1){
        var idToDelete = actions.remove[i];
        idsToRemoveFromRootGroup[idToDelete] = true;
        delete tree[idToDelete];
    }
    for(var i1 = 0; i1 < actions.insert.length; i1 += 1){
        var idToInsert = actions.insert[i1];
        tree[idToInsert] = {
            id: idToInsert,
            depth: 0,
            parent: GRID_ROOT_GROUP_ID,
            type: 'leaf',
            groupingKey: null
        };
    }
    // TODO rows v6: Support row unpinning
    var rootGroup = tree[GRID_ROOT_GROUP_ID];
    var rootGroupChildren = _to_consumable_array(rootGroup.children).concat(_to_consumable_array(actions.insert));
    if (Object.values(idsToRemoveFromRootGroup).length) {
        rootGroupChildren = rootGroupChildren.filter(function(id) {
            return !idsToRemoveFromRootGroup[id];
        });
    }
    tree[GRID_ROOT_GROUP_ID] = _extends({}, rootGroup, {
        children: rootGroupChildren
    });
    return {
        groupingName: GRID_DEFAULT_STRATEGY,
        tree: tree,
        treeDepths: {
            0: rootGroupChildren.length
        },
        dataRowIds: rootGroupChildren
    };
};
var flatRowTreeCreationMethod = function(params) {
    if (params.updates.type === 'full') {
        return createFlatRowTree(params.updates.rows);
    }
    return updateFlatRowTree({
        previousTree: params.previousTree,
        actions: params.updates.actions
    });
};
export var useGridRowsPreProcessors = function(apiRef) {
    useGridRegisterStrategyProcessor(apiRef, GRID_DEFAULT_STRATEGY, 'rowTreeCreation', flatRowTreeCreationMethod);
};
